import React, { useState } from "react";
import { DeleteOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { ExpressionRenderer } from "./ExpressionRenderer";
import BuilderInteractor from "../builder.interactor";
import { CaseExpression as CaseExpressionType } from "../types2";

interface CaseExpressionProps {
  expr: CaseExpressionType;
  path: string[];
  interactor: BuilderInteractor;
}

export const CaseExpression: React.FC<CaseExpressionProps> = ({
  expr,
  path,
  interactor,
}) => {
  // Track collapse state for each branch
  const [collapsedBranches, setCollapsedBranches] = useState<{ [key: number]: boolean }>({});

  const toggleBranch = (index: number) => {
    setCollapsedBranches(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <div className="case-expression-container">
      <div className="case-keyword">CASE</div>
      <div className="case-branches">
        {expr.branchOperand &&
          expr.branchOperand.map((operand, index) => (
            <div key={index} className="case-branch">
              <div 
                className={`collapse-icon ${collapsedBranches[index] ? 'plus' : 'minus'}`}
                onClick={() => toggleBranch(index)}
              >
                {collapsedBranches[index] ? '-' : '+'}
              </div>
              <div className="case-when-container">
                <div className="case-when-label">WHEN</div>
                {!collapsedBranches[index] && (
                  <>
                    <div className="case-condition">
                      <ExpressionRenderer
                        requiredExpMenu={true}
                        expr={operand.conditionOperand.operand}
                        path={[
                          ...path,
                          "branchOperand",
                          index.toString(),
                          "conditionOperand",
                          "operand",
                        ]}
                        interactor={interactor}
                      />
                    </div>
                    <div className="case-then-label">THEN</div>
                    <div className="case-result">
                      <ExpressionRenderer
                        requiredExpMenu={true}
                        expr={operand.resultOperand.operand}
                        path={[
                          ...path,
                          "branchOperand",
                          index.toString(),
                          "resultOperand",
                          "operand",
                        ]}
                        interactor={interactor}
                      />
                    </div>
                  </>
                )}
                <DeleteOutlined
                  className="delete-branch-button"
                  onClick={() =>
                    interactor.removeCWTBranchOperand([...path, "branchOperand"], index)
                  }
                />
              </div>
            </div>
          ))}
      </div>
      <div className="case-actions">
        <PlusCircleOutlined
          className="add-branch-button"
          onClick={() =>
            interactor.addCWTBranchOperand([...path, "branchOperand"])
          }
        />
      </div>
      <div className="case-else-container">
        <div className="case-keyword">ELSE</div>
        <div className="case-default">
          <ExpressionRenderer
            requiredExpMenu={true}
            expr={expr.defaultOperand}
            path={[...path, "defaultOperand"]}
            interactor={interactor}
          />
        </div>
      </div>
      <div className="end-keyword">END</div>
    </div>
  );
}; 